export const pathologyTodoAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }